// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1-j0J","row":"ProcedureTreatmentSummary_row__3gku4"};